import { render } from "./News.vue?vue&type=template&id=67c8fd40&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=67c8fd40&lang=scss&scoped=true"
import "./News.vue?vue&type=style&index=1&id=67c8fd40&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c8fd40"]])

export default __exports__